// extracted by mini-css-extract-plugin
export var ctaContainer = "related-products-module--ctaContainer--61c6d";
export var description = "related-products-module--description--e1447";
export var productDetails = "related-products-module--productDetails--8709c";
export var productSubtitle = "related-products-module--productSubtitle--78702";
export var wrapper = "related-products-module--wrapper--a4fd4";